import { render, staticRenderFns } from "./PrinterTable.vue?vue&type=template&id=0972bbff"
import script from "./PrinterTable.vue?vue&type=script&lang=ts"
export * from "./PrinterTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports